export default {"src":"/_next/static/media/hassleFreeDocs.cd613e54.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};